/**
 * Every cache key in one place, so two screens asking for the same thing
 * cannot miss each other over a typo.
 *
 * Each is scoped by restaurant: the guest app is always inside one, and a key
 * without it would serve one venue's menu to another on a shared device.
 */
export const queryKeys = {
  dishes: (restaurantId: string) => ["dishes", restaurantId] as const,
  categories: (restaurantId: string) => ["categories", restaurantId] as const,
  toppings: (restaurantId: string) => ["toppings", restaurantId] as const,
  sizes: (restaurantId: string) => ["dish-sizes", restaurantId] as const,
  menuTypes: (restaurantId: string) => ["menu-types", restaurantId] as const,
  waiters: (restaurantId: string) => ["waiters", restaurantId] as const,
  allergens: () => ["allergens"] as const,
  diets: () => ["diets"] as const,
  spiceLevels: () => ["spice-levels"] as const,
  units: () => ["units"] as const,
  ingredients: (restaurantId: string) => ["ingredients", restaurantId] as const,
} as const;
